<template>
<div >
  <div class="detailsTitle">
      <h4>订单详情</h4>
      <div @click="back"><i class="fa fa-reply"></i></div>
  </div>
  <el-form :inline="true" ref="goodform" enctype="multipart/form-data" :model="goodform" label-position="right" label-width="120px"   class="demo-form-inline" size="mini">
    <div class="addressBox">
         <h4 class="title">
          <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>单据信息</span>
        </h4>
    </div>
    <el-form-item label="订单编号:"  >
      <div class="width2">{{goodform.orderNo}}</div>
    </el-form-item>
    <el-form-item label="外部单号:" >
      <div class="width2">{{goodform.externalOrderNumber}}</div>
    </el-form-item>
    <el-form-item label="销售合同:"  >
      <div class="width2">{{goodform.salesContract?goodform.salesContract:'-'}}</div>
    </el-form-item>
     <el-form-item label="合同结束日期:" >
      <div class="width2">{{goodform.contractEndDate|dateFormat1}}</div>
    </el-form-item>
    <el-form-item label="合同提醒天数:" prop="contractReminderDays">
     <div class="width2">{{goodform.contractReminderDays?goodform.contractReminderDays:'-'}}</div>
    </el-form-item>
     <el-form-item label="账期预警节点" prop="accountNodeSet"  >
       <div class="width2">{{['装船','到港'][goodform.accountNodeSet]}}</div>
    </el-form-item>
    <el-form-item label="账期预警天数:" prop="accountReminderDays" >
      <div class="width2">{{goodform.accountReminderDays?goodform.accountReminderDays:'-'}}</div>
    </el-form-item>
    <el-form-item label="项目名称:"  >
      <div class="width2">{{goodform.projectType}}</div>
    </el-form-item>
    <el-form-item label="业务类型:"  >
      <div class="width2">{{goodform.orderBusinessTypeName}}</div>
    </el-form-item>
    <el-form-item label="业务部门:"  >
      <div class="width2">{{goodform.businessUnit}}</div>
    </el-form-item>
    <el-form-item label="业务人员:" >
      <div class="width2">{{goodform.businessUser}}</div>
    </el-form-item>
    <el-form-item label="结算客户:"  >
      <div class="width2">{{goodform.payee}}</div>
    </el-form-item>
    <hr>
    <div class="addressBox">
         <h4 class="title">
          <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>收发信息</span>
        </h4>
    </div>
    <div>
      <el-form-item   label="起运港:" prop="startDirection">
         <div style="width:300px">{{goodform.startDirection}}</div>
      </el-form-item>
      <el-form-item label="目的港:" prop="endDirection" >
          <div style="width:300px">{{goodform.endDirection}}</div>
      </el-form-item>
    </div>
    <div>
      <el-form-item    label="发货人:" prop="deliverPerson" >
        <div style="width:80px">{{goodform.deliverPerson}}</div>
      </el-form-item>
      <el-form-item label="电话:" prop="deliverPhone" >
         <div style="width:80px">{{goodform.deliverPhone}}</div>
      </el-form-item>
      <el-form-item  label="发货地址:" prop="deliverAddress" class="diqu1" >
         <div style="min-width:150px">{{goodform.deliverAddress}}</div>
      </el-form-item>
    </div>
    <div>
      <el-form-item  label="收货人:" prop="receivingPerson" >
         <div style="width:80px">{{goodform.receivingPerson}}</div>
      </el-form-item>
      <el-form-item label="电话:" prop="receivingPhone" >
         <div style="width:80px">{{goodform.receivingPhone}}</div>
      </el-form-item>
      <el-form-item  label="收货地址:" prop="receivingAddress" class="diqu1" >
         <div style="min-width:150px">{{goodform.receivingAddress}}</div>
      </el-form-item>
    </div>
    <hr>
     <div class="addressBox">
         <h4 class="title">
          <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>货物信息</span>
        </h4>
    </div>
    <el-form-item  label="货物类型:" >
        <div style="width:80px">{{goodform.productTypeName}}</div>
    </el-form-item>
    <el-form-item  label="计量单位:" >
        <div style="width:80px">{{goodform.measuringUnit}}</div>
    </el-form-item>
    <el-form-item  label="重量(吨):">
        <div style="width:80px">{{goodform.weight?goodform.weight:'-'}}</div>
    </el-form-item>
    <el-form-item  label="数量(件):">
        <div style="width:80px">{{goodform.orderNumber?goodform.orderNumber:'-'}}</div>
    </el-form-item>
    <el-form-item  label="体积(方):">
        <div style="width:80px">{{goodform.volumn?goodform.volumn:'-'}}</div>
    </el-form-item>
    <el-form-item  label="货物备注:">
        <div style="width:80px">{{goodform.productRemark?goodform.productRemark:'-'}}</div>
    </el-form-item>
  <div style="padding:0 16px 16px 16px;" v-if="goodform.goodsList.length>0">
    <el-table height="300px" size="mini" ref="tabref" :data="goodform.goodsList" style="width:100%" border center>
      <el-table-column type="index"  label="序号" width="60"></el-table-column>
      <el-table-column :show-overflow-tooltip="true"  prop="customerName"
        label="货权客户" min-width="180" :formatter="formatterRowEmpty"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="cargoBarcode" label="捆包号"
        min-width="180" :formatter="formatterRowEmpty"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="weight" label="重量(吨)"
        min-width="120" :formatter="formatterRowEmpty"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="number" label="数量(件)"
        min-width="120" :formatter="formatterRowEmpty"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="volumn" label="体积(方)"
        min-width="120" :formatter="formatterRowEmpty"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="productName" label="品名"
        min-width="120" :formatter="formatterRowEmpty"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="model" label="材质"
        min-width="120" :formatter="formatterRowEmpty"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格"
        min-width="120" :formatter="formatterRowEmpty"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="cargoLocation" label="货位"
          min-width="120" :formatter="formatterRowEmpty"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="contractNumber" label="合同号"
        min-width="120" :formatter="formatterRowEmpty"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="agreementNumber" label="合约号"
        min-width="120" :formatter="formatterRowEmpty"></el-table-column>
    </el-table>
  </div>
  <hr>
  <div class="addressBox">
        <h4 class="title">
        <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>运单信息</span>
      </h4>
  </div>
  <el-table :data="wayList" ref="xzdz" highlight-current-row  class="tableComent"  style="width: 100%" height="200px" border>
    <el-table-column prop="wayNo" label="运单编号" min-width="180" :formatter="formatterRowEmpty"></el-table-column>
    <el-table-column prop="wayStateName" min-width="80" label="运单状态"></el-table-column>
    <el-table-column prop="createTime" min-width="170" :formatter="dateTimeFormat" label="创建时间"></el-table-column>
    <el-table-column prop="productTypeName" min-width="130" label="货物类型"></el-table-column>
    <el-table-column prop="liquidatedAmountNum" min-width="80" label="结算量" show-overflow-tooltip ></el-table-column>
     <el-table-column prop="measuringUnit" min-width="80" label="结算单位" show-overflow-tooltip ></el-table-column>
    <el-table-column prop="plateNumber" label="船舶名称" min-width="220"></el-table-column>
  </el-table>
  <hr>
  <div class="addressBox">
        <h4 class="title">
        <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>收入信息</span>
      </h4>
  </div>
  <el-table :data="wayList" ref="xzdz" highlight-current-row  class="tableComent"  style="width: 100%" height="260px" border>
   <el-table-column prop="wayNo" label="运单编号" min-width="120" :formatter="formatterRowEmpty"></el-table-column>
    <el-table-column prop="payee" min-width="180" label="结算客户/部门"></el-table-column>
    <el-table-column prop="incomePatternName" min-width="100"  label="收入方式"></el-table-column>
    <el-table-column prop="ysSettlementStates" min-width="130" label="结算状态"></el-table-column>
    <el-table-column prop="ysInvoicingStates" min-width="80" label="开票状态" show-overflow-tooltip ></el-table-column>
    <el-table-column prop="salesContract" label="销售合同" min-width="180" :formatter="formatterRowEmpty"></el-table-column>
    <el-table-column prop="ticketSystemYn" min-width="100" label="是否一票制"></el-table-column>
    <el-table-column prop="makeTicketYn" min-width="80"  label="是否开票"></el-table-column>
    <el-table-column prop="revenueValuationName" min-width="80" label="收入计价"></el-table-column>
    <el-table-column prop="incomeUnitPrice" min-width="140" label="收入含税单价(元)"  :formatter="formatterRowEmpty" ></el-table-column>
    <el-table-column prop="incomeNoUnitPrice" label="收入不含税单价(元)" min-width="140" :formatter="formatterRowEmpty"></el-table-column>
    <el-table-column prop="taxRate" min-width="110" label="收入税率(%)"></el-table-column>
    <el-table-column prop="incomeAmount" min-width="130"  :formatter="formatterRowEmpty" label="收入金额(元)"></el-table-column>
    <el-table-column prop="revenueSurcharge" min-width="130" :formatter="formatterRowEmpty"  label="收入附加费(元)"></el-table-column>
     <el-table-column prop="grossRevenue" min-width="130"  :formatter="formatterRowEmpty" label="收入含税总额(元)"></el-table-column>
    <el-table-column prop="grossNoRevenue" min-width="140" :formatter="formatterRowEmpty"  label="收入不含税总额(元)"></el-table-column>
     <el-table-column prop="incomeTaxAmount" min-width="130"  :formatter="formatterRowEmpty" label="收入税额(元)"></el-table-column>
    <el-table-column prop="revenueSurcharge" min-width="130" :formatter="formatterRowEmpty"  label="收入附加费(元)"></el-table-column>
     <el-table-column prop="incomeAmount" min-width="130"  :formatter="formatterRowEmpty" label="收入金额(元)"></el-table-column>
    <el-table-column prop="ysPaymentAmount" min-width="130" :formatter="formatterRowEmpty"  label="收款金额(元)"></el-table-column>
     <el-table-column prop="ysNoPaymentAmount" min-width="130"  :formatter="formatterRowEmpty" label="未收款金额(元)"></el-table-column>
    <el-table-column prop="ysInvoiceAmount" min-width="130" :formatter="formatterRowEmpty"  label="收入已开票(元)"></el-table-column>
     <el-table-column prop="ysNoInvoiceAmount" min-width="130"  :formatter="formatterRowEmpty" label="收入未开票(元)"></el-table-column>
    <el-table-column prop="ysInvoiceOn" min-width="130" :formatter="formatterRowEmpty"  label="收入发票号"></el-table-column>
    <el-table-column prop="ysPaymentTime" min-width="170" :formatter="dateTimeFormat" label="收款日期"></el-table-column>

  </el-table>
  <hr>
  <div class="addressBox">
        <h4 class="title">
        <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>支出信息</span>
      </h4>
  </div>
  <el-table :data="wayList" ref="xzdz" highlight-current-row  class="tableComent"  style="width: 100%" height="260px" border>
   <el-table-column prop="wayNo" label="运单编号" min-width="120" :formatter="formatterRowEmpty"></el-table-column>
    <el-table-column prop="payer" min-width="180" label="收款方"></el-table-column>
    <el-table-column prop="expenditurePatternName" min-width="100"  label="支出方式"></el-table-column>
    <el-table-column prop="yfSettlementStates" min-width="130" label="结算状态"></el-table-column>
    <el-table-column prop="yfInvoicingStates" min-width="80" label="开票状态" show-overflow-tooltip ></el-table-column>
    <el-table-column prop="freightPricingTypeName" min-width="80" label="运费计价"></el-table-column>
    <el-table-column prop="freightUnitPrice" min-width="140" label="运费单价(元)"  :formatter="formatterRowEmpty" ></el-table-column>
    <el-table-column prop="freightAmount" label="运费金额(元)" min-width="140" :formatter="formatterRowEmpty"></el-table-column>
     <el-table-column prop="disburseSurcharge" label="支出附加费(元)" min-width="140" :formatter="formatterRowEmpty"></el-table-column>
      <el-table-column prop="freightAmountTotal" label="运费总额(元)" min-width="140" :formatter="formatterRowEmpty"></el-table-column>
    <el-table-column prop="serviceRate" min-width="110" label="服务费率(%)"></el-table-column>
    <el-table-column prop="serviceCharge" min-width="130"  :formatter="formatterRowEmpty" label="服务费(元)"></el-table-column>
    <el-table-column prop="freightTaxTotal" min-width="130" :formatter="formatterRowEmpty"  label="支出含税总额(元)"></el-table-column>
     <el-table-column prop="expendTaxUnitPrice" min-width="130"  :formatter="formatterRowEmpty" label="支出含税单价(元)"></el-table-column>
         <el-table-column prop="freightTaxRate" min-width="110" label="运费税率(%)"></el-table-column>
    <el-table-column prop="expendNoTaxUnitPrice" min-width="140" :formatter="formatterRowEmpty"  label="支出不含税单价(元)"></el-table-column>
     <el-table-column prop="freightNoAmountTotal" min-width="130"  :formatter="formatterRowEmpty" label="支出不含税总额(元)"></el-table-column>
    <el-table-column prop="expendTaxAmount" min-width="130" :formatter="formatterRowEmpty"  label="支出税额(元)"></el-table-column>
     <el-table-column prop="yfPaymentAmount" min-width="130"  :formatter="formatterRowEmpty" label="已付款金额(元)"></el-table-column>
    <el-table-column prop="yfNoPaymentAmount" min-width="130" :formatter="formatterRowEmpty"  label="未付款金额(元)"></el-table-column>
    <el-table-column prop="yfInvoiceAmount" min-width="130" :formatter="formatterRowEmpty"  label="支出已开票(元)"></el-table-column>
     <el-table-column prop="yfNoInvoiceAmount" min-width="130"  :formatter="formatterRowEmpty" label="支出未开票(元)"></el-table-column>
    <el-table-column prop="yfInvoiceOn" min-width="130" :formatter="formatterRowEmpty"  label="支出发票号"></el-table-column>
    <el-table-column prop="paymentOaNo" min-width="170"  label="付款申请单号"></el-table-column>
    <el-table-column prop="yfPaymentTime" min-width="170" :formatter="dateTimeFormat" label="付款日期"></el-table-column>

  </el-table>
  <hr>
  <div class="addressBox inpBox" style="margin-bottom:20px;" >
    <h4 class="title">
      <span><i class="fa fa-bookmark iconFont" aria-hidden="true"></i>收入结算信息</span>
    </h4>
    <el-table :data="[{}]"  ref="table"  bordersize="mini" class="tableBox" style="" max-height="500px"  center border>
      <el-table-column label="收入方式" min-width="120">
        <template >
          <div>
            {{[ "月结", "现结"][goodform.incomePattern]}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="是否开票" min-width="120">
        <template >
          <div>
             {{goodform.makeTicketYn}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="是否一票制" min-width="120">
        <template >
          <div>
             {{goodform.ticketSystemYn}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="收入计价" min-width="120">
        <template >
          <div>
            {{goodform.revenueValuationName}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="收入单价(元)" min-width="120">
        <template >
          <div>
             {{goodform.incomeUnitPrice|moneyFormatNew}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="收入金额(元)" min-width="120">
        <template >
          <div>
             {{goodform.incomeAmount|moneyFormatNew}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="收入税率" min-width="120">
        <template >
          <div>
             {{goodform.taxRate}}%
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <div class="addressBox">
    <h4 class="title">
      <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>附件</span>
    </h4>
  </div>
  <div class="fujianBox">
      <el-button type="text" v-for="item in fujianList" @click="fujianClick(item)" :key="item.id">{{item.name}}</el-button>
  </div>
  <hr>
  <div class="addressBox">
    <h4 class="title">
      <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>操作日志</span>
    </h4>
  </div>
  <div style="margin-left:24px">
    <el-timeline>
    <el-timeline-item
        v-for="(item, index) in logList"   color="rgb(147, 210, 243)"
        :key="index"
        :timestamp="item.createTime|dateFormat">
        {{item.content}}&nbsp;&nbsp;{{item.createUser}}<br>
        <spna v-if="item.content=='作废'">作废原因：{{item.remark}}</spna>
      </el-timeline-item>
    </el-timeline>
  </div>
</el-form>
<el-dialog  title="查看图片" :close-on-click-modal="false" :close-on-press-escape="false"   :visible.sync="lookImgFlag"
  append-to-body width="800px" center>
  <div style="text-align: right;">
    <div id="printMe"  ref="print">
      <el-image style="width: 100%;" :src="imgUrl" fit="contain"></el-image>
    </div>
  </div>
</el-dialog>
</div>
</template>

<script>
import { getOrderInfo, companyQuery } from '@/api/newTMS'
import { formatterRowEmpty, dateFormat, dateTimeFormat } from '@/utils/util'
export default {
  data () {
    let id = this.$route.query.id
    return {
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      formatterRowEmpty: formatterRowEmpty,
      id: id,
      goodform: { goodsList: [] },
      fujianList: [],
      lookImgFlag: false,
      imgUrl: '',
      logList: [],
      wayList: []
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    getOrderInfo({ orderBusinessId: this.id }).then(res => {
      this.goodform = res.tOrder
      this.logList = res.serviceLogList
      this.fujianList = []
      res.tAttachmentsList.forEach(item => {
        var filename = item.url.split('/').pop()
        this.fujianList.push({
          name: filename,
          url: item.fileKeyUrl
        })
      })
      this.$set(this.goodform, 'payee', res.tOrderBusiness.payee)
      this.$set(this.goodform, 'orderBusinessType', res.tOrder.orderBusinessType.toString())
      this.$set(this.goodform, 'productType', res.tOrder.productType.toString())
      this.$set(this.goodform, 'goodsList', res.goodslist)
      if (res.tOrderBusiness.incomePattern.toString()) {
        this.$set(this.goodform, 'incomePattern', res.tOrderBusiness.incomePattern.toString())
      }
      if (res.tOrderBusiness.revenueValuation.toString()) {
        this.$set(this.goodform, 'revenueValuation', res.tOrderBusiness.revenueValuation.toString())
        this.$set(this.goodform, 'revenueValuationName', res.tOrderBusiness.revenueValuationName)
      }
      this.$set(this.goodform, 'makeTicketYn', res.tOrderBusiness.makeTicketYn)
      this.$set(this.goodform, 'ticketSystemYn', res.tOrderBusiness.ticketSystemYn)
      this.$set(this.goodform, 'incomeUnitPrice', res.tOrderBusiness.incomeUnitPrice / 100)
      this.$set(this.goodform, 'incomeAmount', res.tOrderBusiness.incomeAmount / 100)
      this.$set(this.goodform, 'taxRate', res.tOrderBusiness.taxRate)
      companyQuery({ orderNos: res.tOrder.orderNo, pageNo: 1, pageSize: 50 }).then(res => {
        this.wayList = res.list
      })
    })
  },
  methods: {
    fujianClick (row) {
      if (this.isImage(row.name)) {
        this.lookImgFlag = true
        this.imgUrl = row.url
      } else {
        window.open(row.url)
      }
    },
    isImage (filename) {
      const extension = filename.split('.').pop().toLowerCase()
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg']
      return imageExtensions.includes(extension)
    },
    back () {
      this.$router.go(-1)// 返回上一层
    }
  }

}
</script>

<style scoped lang='less'>
  .width1{
    width:150px
  }
  .width2{
    width: 260px;
  }
  .dizhiIcon{
  font-size: 18px;
  margin-right: 4px;
}
.fujianBox{
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  /deep/.el-button--text{
    text-align: left;
    margin-left: 0;
    margin-bottom: 10px;
  }
}
/deep/.el-form-item{
  padding-left:24px;
}
/deep/.el-form-item__label{
  color: #999;
}
</style>
